export default __webpack_public_path__ + "static/media/WhiteProfileIcon.4f5ba458.svg";